export default function getBoxes (stl) {
  const lines = stl.split('\n')
  const min = { x: Infinity, y: Infinity, z: Infinity }
  const max = { x: -Infinity, y: -Infinity, z: -Infinity }
  lines.forEach((line) => {
    const parts = line.split(/\s+/)
    if (parts[1] === 'vertex') {
      const x = parseFloat(parts[2])
      const y = parseFloat(parts[3])
      const z = parseFloat(parts[4])
      min.x = Math.min(min.x, x)
      min.y = Math.min(min.y, y)
      min.z = Math.min(min.z, z)
      max.x = Math.max(max.x, x)
      max.y = Math.max(max.y, y)
      max.z = Math.max(max.z, z)
    }
  })

  const round = (num) => Math.round(num * 100000) / 100000
  const box0 = {
    type: 'searchableBox',
    mode: 'inside',
    min: [
      round(1.3 * min.x / 1000),
      round(2 * min.y / 1000),
      round(2 * min.z / 1000)
    ],
    max: [
      round(1.3 * max.x / 1000),
      round(2 * max.y / 1000),
      round(2 * max.z / 1000)
    ],
    level: 4,
  }
  const box1 = {
    type: 'searchableBox',
    mode: 'inside',
    min: [
      round(0.85 * max.x / 1000),
      round(min.y / 2000),
      round(min.z / 2000)
    ],
    max: [
      round(1.15 * max.x / 1000),
      round(max.y / 2000),
      round(max.z / 2000)
    ],
    level: 5,
  }
  return { box0, box1 }
}
